<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
import { mapState } from "vuex";
import Clipboard from 'clipboard'
import wxShare from "@/utils/wechat";
export default {
  components: {},
  mixins: [wxShare],
  data() {
    return {
      showShare: false,
      shareOptions: [
        { name: "微信", icon: "wechat" },
        { name: "朋友圈", icon: "wechat-moments" },
        { name: "微博", icon: "weibo" },
        { name: "QQ", icon: "qq" },
        { name: "复制链接", icon: "link" },
      ],

      bannerVisible: true,
      banner: [],

      article_id: null, //文章ID
      info: {}, //文章详情

      reply_content: null, //评论内容

      RefreshLoading: false, //刷新
      Loading: false, //加载
      Finished: false, //加载完成
      List: [],
      pagination: {
        index: 0,
        pages: 0,
        size: 20,
        total: 0,
      },

      showSend: false,

      artUrl: null,
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title'])
  },
  watch: {},
  created: function () {},
  mounted: function () {
    var article_id = this.$route.params.article_id;
    this.article_id = article_id;
    this.getArtInfo();
    //获取广告
    this.$api.articleAdvertPage().then((res) => {
      console.log(res);
      this.banner = res.data.data || [];
    });
    this.artUrl = window.location.href;
  },
  methods: {
    jumpExpert(item){
      if(['temp','official','manager'].indexOf(item.userType)===-1){
        this.$glf.goUrl('push','/expert_info/'+item.userId);
      }
      // if(item.userType!=='temp'){
      //   this.$glf.goUrl('push','/expert_info/'+item.userId);
      // }
    },
    //查看大图
    lookBigImg(row,index){
      console.log(this);
      var imgs = this.$glf.parseObj(this.info.imgs);
      imgs = imgs.map(r=>this.$glf.dealImg(r));
      this.$ImagePreview(imgs,index);
    },

    //获取文章详情
    getArtInfo(){
      this.$api.articleDetail({ id: this.article_id }).then((res) => {
        if (!res.data) {
          this.$toast("未找到相关文章");
          this.$router.back();
        } else {
          var fo = res.data;
          if(fo.imgs){
            fo.imgs = JSON.parse(fo.imgs);
          }else{
            fo.imgs = [];
          }
          this.info = fo;

          let url = window.location.origin;
          const shareInfo = {
            title: fo.title,
            desc: this.$glf.getText(fo.content),
            link: `${url}`+this.$route.fullPath,
            img: `${url}/static/image/share.png?v=1111`,
          };
          // const shareInfo = {
          //   title: "歆医荟",
          //   desc: "歆医荟",
          //   link: `${url}/master`,
          //   img: `${url}/static/image/share.png?v=11`,
          // };
          this.wechatShare(shareInfo);
        }
      });
    },

    //收藏文章 - 收藏文章发布人
    doCollect(){
      if(!this.info.myFavStatus){
        //收藏
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.userFav({favUserId:this.info.userId}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:1,msg: '收藏成功！',tip:'查看我收藏的所有专家'});
          this.getArtInfo();
        })
      }else{
        //取消收藏
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.userUnFav({favUserId:this.info.userId}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:1,msg: '取消收藏成功！',tip:'查看我收藏的所有专家'});
          this.getArtInfo();
        })
      }
    },



    //给文章点赞
    dealArtZan(){
      if(!this.info.myThumbupStatus){
        //点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleThumbupAdd({articleId:this.article_id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '点赞成功！',tip:'感谢您的点赞'});
          this.getArtInfo();
        })
      }else{
        //取消点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleThumbupDelete({articleId:this.article_id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '取消点赞成功！',tip:'我会继续努力地'});
          this.getArtInfo();
        })
      }
    },

    //给评论点赞
    dealPingZan(row,index){
      if(!row.myThumbupStatus){
        //点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyThumbupAdd({replyId:row.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '点赞成功！',tip:'感谢您的点赞'});
          this.List[index].myThumbupStatus = true;
          this.List[index].thumbupNum += 1;
        })
      }else{
        //取消点赞
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          loadingType: "spinner",
          duration: 0,
        });
        this.$api.articleReplyThumbupDelete({replyId:row.id}).then(res=>{
          this.$toast.clear();
          this.$wlAlert({type:2,msg: '取消点赞成功！',tip:'我会继续努力地'});
          this.List[index].myThumbupStatus = false;
          this.List[index].thumbupNum -= 1;
        })
      }
    },

    //提交评论
    subReply() {
      if (this.$glf.isEmpty(this.reply_content)) {
        this.$toast("评论内容不能为空");
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var params = {
        articleId: this.article_id,
        content: this.reply_content,
      };
      this.$api.articleReplyAdd(params).then((res) => {
        this.reply_content = null;
        this.$toast("评论成功");
        this.refreshList();
        this.showSend=false;
        this.getArtInfo();
      });
    },

    //刷新列表
    refreshList() {
      this.pagination.index = 0;
      this.Finished = false;
      this.loadList().then((res) => {
        this.RefreshLoading = false;
      });
    },
    //加载列表
    loadList() {
      // 异步更新数据
      var params = {
        pagination: {
          index: this.pagination.index+1,
          size: this.pagination.size,
        },
        articleId: this.article_id,
        // condition: {
        //   stc: "1",
        //   items: [{ code: "articleId", opc: "=", values: [this.article_id] }],
        // },
        sort: [{ code: "ct", desc: true }],
      };
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.$api.articleReplyPage(params).then((res) => {
          var data = res.data;
          var list = data.data || [];
          if (data.pagination.index === 1) {
            _this.List = list;
          } else {
            _this.List = _this.List.concat(list);
          }
          _this.pagination = data.pagination;
          // 数据全部加载完成
          if (_this.List.length >= data.pagination.total) {
            _this.Finished = true;
          }
          // 加载状态结束
          _this.Loading = false;
          resolve();
        });
      });
    },

    showSharePannel() {
      var clipboard = new Clipboard('.copyStr')
      // console.log(clipboard);
      clipboard.on('success', e => {
          console.log('复制成功')
      })
        clipboard.on('error', e =>{
        // 不支持复制
        console.log('该浏览器不支持复制')
      })
      this.showShare = true;
    },
    onShareSelect(option) {
      console.log("分享参数", option);
      //文章分享数+1
      if(this.authToken){
        this.$api.articleShareAdd({articleId:this.article_id})
      }
      this.$wlAlert({type:2,msg: '链接复制成功！',tip:'可以前往其他平台粘贴了'});
      this.showShare = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/article_info/index.vue